export default __webpack_public_path__ + "static/media/pumpkin211.fcbd3214.png";